<div style="margin-bottom: 50px;">
  <div class="div-gradient px-2">
    <div style="position: relative;">
      <div class="div-limiar" style="left: 10%;">
        <div class="float-div float-div-text">
          <span class="float-div-text-title">MENOR VALOR </span>
          <br />
          <span class="float-div-price">R$ {{ prices.min | number: '1.0-0'  }}</span>
        </div>
      </div>
      <div class="div-limiar" style="left: 50%;">
        <div class="float-div float-div-text">
          <span class="float-div-text-title">PREÇO MÉDIO</span>
          <br />
          <span class="float-div-price" style="font-size: 24px; font-weight: bold;">R$
            {{ prices.average | number: '1.0-0'  }}</span>
        </div>
      </div>
      <div class="div-limiar" style="left: 90%;">
        <div class="float-div float-div-text">
          <span class="float-div-text-title">MAIOR VALOR </span><br />
          <span class="float-div-price">R${{ prices.max  | number: '1.0-0' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>